import Icon from 'flow/components/ui-components/Icon';
import AppContext from 'flow/contexts/app-context';
import React, { useContext } from 'react';

interface Props {
    handleRemoveAttachment: () => void;
}

const RemoveAttachmentButton = ({ handleRemoveAttachment }: Props) => {
    const { i18next } = useContext(AppContext);

    return (
        <button onClick={handleRemoveAttachment}>
            <span className="sr-only">
                {i18next.t('Chat.Tooltip.Remove.Attachment')}
            </span>
            <Icon iconKey="close" className="size-5" />
        </button>
    );
};

export default RemoveAttachmentButton;
